import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import TextEditor from 'flarum/common/components/TextEditor';
import Tooltip from 'flarum/common/components/Tooltip';
import classList from 'flarum/common/utils/classList';
import ProseMirrorEditorDriver from './proseMirror/ProseMirrorEditorDriver';
import ProseMirrorMenu from './components/ProseMirrorMenu';
import MenuState from './states/MenuState';
import KeyboardAwareComposerHeight from './utils/KeyboardAwareComposerHeight';
export default function applyEditor() {
  if (!TextEditor || !TextEditor.prototype) {
    return;
  }
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    items.remove('markdown');
    items.add('prosemirror-menu', m(ProseMirrorMenu, {
      state: this.menuState
    }), 100);
  });
  extend(TextEditor.prototype, 'buildEditorParams', function (items) {
    items.menuState = this.menuState = new MenuState();
    items.classNames.push('Post-body');
    items.escape = () => app.composer.close();
    m.redraw();
  });
  override(TextEditor.prototype, 'buildEditor', function (original, dom) {
    this.keyboardAwareComposerHeight?.destroy();
    const editor = new ProseMirrorEditorDriver(dom, this.buildEditorParams());
    this.keyboardAwareComposerHeight = new KeyboardAwareComposerHeight(this.$('.TextEditor')[0]);
    return editor;
  });
  extend(TextEditor.prototype, 'onremove', function () {
    this.keyboardAwareComposerHeight?.destroy();
  });
}
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/applyEditor', applyEditor);